/**
 * Speichert und lädt die WBT-Einstellungen
 * @class service_v3sWbtSettingsService
 * @memberOf v3sWbtPlayerApp:wbt
 */
angular.module('v3sWbtPlayerApp').factory('v3sWbtSettingsService', ["$rootScope", function ($rootScope) {

    var settings = {
        "muteAudio": false,
        "showSubtitle": false
    };

    var changed = false;

    function get(name) {
        if (typeof settings[name] != "undefined") {
            return settings[name];
        } else {
            return angular.copy(settings);
        }
    }

    function set(newSettings) {
        if (!!newSettings && !angular.equals(settings, newSettings)) {
            angular.extend(settings, newSettings);
            notifySettingsChanged();
        }
    }

    function update(newSettings) {
        if (!angular.equals(settings, newSettings)) {
            set(newSettings);
            changed = true;
        }
    }

    function getChangeCount() {
        return changed ? 1 : 0;
    }

    function resetChangeCount() {
        changed = false;
    }


    function subscribeSettingsChanged(scope, callback) {
        var handler = $rootScope.$on('v3sWbtSettingsChanged', callback);
        if (scope) {
            scope.$on('$destroy', handler);
        }
    }

    function notifySettingsChanged() {
        $rootScope.$emit('v3sWbtSettingsChanged', this);
    }

    return {
        get: get,
        set: set,
        update: update,
        getChangeCount: getChangeCount,
        resetChangeCount: resetChangeCount,
        subscribeSettingsChanged: subscribeSettingsChanged
    }
}]);